<template>
	<div>
		<div class="bgCol second">
			
		    <div class="item files">
		        <div class="label">请拍摄工作照一张:</div>
		        <el-upload
		                :action="uploadAction"
		                :headers="myHeaders"
						:show-file-list="false"
		                :on-success="handleWorkSuccess" v-if="is_edit===true">
						<img v-if="work_image!=''" :src="work_image"
							class="avatar" style="width: 200px; height: 200px; " >
		            <div class="crop" v-else></div>
		        </el-upload>	
						   <img v-else :src="work_image"
						   	class="avatar" style="width: 200px; height: 200px; " >
		    </div>
		</div>
		
	</div>
</template>
<script>
	
	import axios from 'axios';
		export default {
			name: "Work",
			props: {
				work_task_id: {
					type: Number,
					default: 0
				},	
				is_edit: {
					type: Boolean,
					default: false
				},	
				image: {
					type: String,
					default: ''
				},	
			},
			data() {
				return {
					uploadAction: axios.defaults.baseURL + "/upload/image",
					myHeaders: {
						authorization: "Bear " + localStorage.getItem("token")
					},
					work_image:this.image,
  
				}
				},
				mounted() {
					//console.log(this.work_image)
				},
				methods:{
					handleWorkSuccess(response, file, fileList) {
						this.work_image=response.data
					},
					beforeUpload(file) {
						const isJPG = file.type === 'image/jpeg';
						const isPng = file.type === 'image/png';
						const isLt2M = file.size / 1024 / 1024 < 2;
						if (!isLt2M) {
							this.$message.error('上传图片大小不能超过 2MB!');
						}
						if (!isJPG && !isPng) {
					
							this.$message.error('上传图片只能是 JPG或PNG 格式!');
							return false
						} else {
							return true
						}
					},
					
				}
			}
		

</script>

<style>
</style>
